import React from "react";
import { Link } from "react-router-dom";
import {
  TfiFacebook,
  TfiInstagram,
  TfiYoutube,
  TfiTwitterAlt,
} from "react-icons/tfi";
import UseTitle from "../../Hooks/UseTitle";

const Footer = () => {
  return (
    <div className="footerBg ">
      <div className="max-w-screen-xl mx-auto py-20  xl:px-10">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 gap-10 sm:px-10">
          <div className="flex justify-center md:justify-start">
            <div className="text-center md:text-start">
              <h1 className="text-[25px] capitalize mb-3 font-bold matir-maya">
                Matir Maya Eco Resort
              </h1>
              <p className="text-[17px] capitalize">
                Uttar-Pelayed, Telihaty, Gazipur-1740, Bangladesh
              </p>
              <p className="text-[22px] mt-3 font-bold">
                {" "}
                <span className="text-[#bb4f32] font-bold">Hotline:</span> +880
                1867 877 677
              </p>
              <div className="pt-5">
                <h1 className="text-[25px] text-center md:text-start font-bold">
                  Join Us
                </h1>
                <div className="flex md:justify-start justify-center gap-5 mt-6">
                  <a
                    href="https://www.facebook.com/MatirMayaEcoResort"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <TfiFacebook className="text-[25px] hover:cursor-pointer hover:text-[#bb4f32]" />
                  </a>

                  <TfiTwitterAlt className="text-[25px] hover:cursor-pointer hover:text-[#bb4f32]" />
                  <TfiInstagram className="text-[25px] hover:cursor-pointer hover:text-[#bb4f32]" />
                  <TfiYoutube className="text-[25px] hover:cursor-pointer hover:text-[#bb4f32]" />
                </div>
              </div>
            </div>
          </div>

          <div className="text-center ">
            <div className="text-center md:text-start">
              <p className="text-[17px] mb-2 hover:text-[#bb4f32]">
                <Link
                  to="/"
                  className="hover:no-underline  "
                  rel="noopener noreferrer"
                >
                  Home
                </Link>
              </p>
              <p className="text-[17px] mb-2 hover:text-[#bb4f32]">
                <Link
                  to="/Rooms"
                  className="hover:no-underline "
                  rel="noopener noreferrer"
                >
                  Accommodations
                </Link>
              </p>
              <p className="text-[17px] mb-2 hover:text-[#bb4f32]">
                <Link
                  to="/Restaurant"
                  className="hover:no-underline"
                  rel="noopener noreferrer"
                >
                  Restaurant
                </Link>{" "}
              </p>
              <p
                className="text-[17px] mb-2 hover:text-[#bb4f32]"
                rel="noopener noreferrer"
              >
                <Link
                  to="/Meeting_and_Events"
                  className="hover:no-underline "
                  rel="noopener noreferrer"
                >
                  Meetings & Events
                </Link>
              </p>
              <p
                className="text-[17px] mb-2 hover:text-[#bb4f32]"
                rel="noopener noreferrer"
              >
                <Link
                  to="/Relaxation"
                  className="hover:no-underline "
                  rel="noopener noreferrer"
                >
                  Relaxations
                </Link>
              </p>
              <p
                className="text-[17px] mb-2 hover:text-[#bb4f32]"
                rel="noopener noreferrer"
              >
                <Link
                  to="/Facilities"
                  className="hover:no-underline "
                  rel="noopener noreferrer"
                >
                  Facilities
                </Link>
              </p>
              <div className="text-center md:text-start">
                <p className="text-[17px] mb-2 hover:text-[#bb4f32]">
                  <Link
                    to="/Recreation"
                    className="hover:no-underline"
                    rel="noopener noreferrer"
                  >
                    Recreation
                  </Link>
                </p>
                <p className="text-[17px] mb-2 hover:text-[#bb4f32]">
                  <Link
                    to="/Online_Booking"
                    className="hover:no-underline"
                    rel="noopener noreferrer"
                  >
                    Online Booking
                  </Link>
                </p>
                <p className="text-[17px] mb-2 hover:text-[#bb4f32]">
                  <Link
                    to="/Gallery"
                    className="hover:no-underline"
                    rel="noopener noreferrer"
                  >
                    Gallery
                  </Link>
                </p>
                <p className="text-[17px] mb-2 hover:text-[#bb4f32]">
                  <Link
                    to="/SpecialOffers"
                    className="hover:no-underline"
                    rel="noopener noreferrer"
                  >
                    Special Offers
                  </Link>
                </p>
                <p className="text-[17px] mb-2 hover:text-[#bb4f32]">
                  <Link
                    to="/Contact"
                    className="hover:no-underline"
                    rel="noopener noreferrer"
                  >
                    Contact
                  </Link>
                </p>
              </div>
            </div>
          </div>

          <div className="flex justify-center content-center border border-white shadow-xl p-8 md:p-0">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d69199.5798858939!2d90.50020682873833!3d24.281797538988993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3756717c98da359b%3A0x7b4d67a1e965542c!2sMatir%20Maya%20Eco%20Resort%2C%20Sreepur%2C%20Gazipur!5e0!3m2!1sen!2sbd!4v1678089584960!5m2!1sen!2sbd"
              allowfullscreen=""
              loading="lazy"
              className="w-full"
              title="Matir-Maya "
            ></iframe>
          </div>
        </div>
        <div className="px-10 ">
          <div className="mt-10 md:p-10 p-5">
            <div className="flex justify-center ">
              <div className="text-center  ">
                <p>
                  <span>
                    © 2023. Matir Maya Eco Resort. All rights reserved.
                  </span>
                </p>
              </div>
            </div>
            <div className="weero pt-1">
              <p className="font-bold text-blue-900 text-center">
                {" "}
                Developed by{" "}
                <a
                  href="https://www.weerodigital.com/"
                  rel="noopener noreferrer"
                >
                  Weero Digital
                </a>{" "}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
